import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import MyLocationIcon from '@mui/icons-material/MyLocation';

import { useSessionContext } from '../../../contexts/SessionContext';

export default function LoadListListItemCurLocation(props){
    //console.debug("RTS Break LoadListListItemCurLocation");

    const {sessionCustomer} = useSessionContext();
    

    function checkNamedLocation(){
        if(props.data.assignedToCustomerIdGuid === sessionCustomer.customer.idGuid){
            if(props.data.curNamedLocation==null){
                return null;
            }
            else{
                return props.data.curNamedLocation;
            }
        }
        else if(props.data.soldToCustomerIdGuid === sessionCustomer.customer.idGuid){
            if(props.data.curSoldToNamedLocation==null){
                return null;
            }
            else{
                return props.data.curSoldToNamedLocation;
            }
        }
        else{
            return null;
        }
    }


    return (
        <>
        {props.data.curLat!==null && props.data.curLng!==null
            ?
            <Box>
                <Typography variant="body2" sx={{fontWeight:'bold'}}>Location:</Typography>
                {checkNamedLocation()===null
                ?
                <a target="_blank" style={{textDecoration:'none', cursor:'pointer', color:'#1976d2'}} href={"https://www.google.com/maps/search/?api=1&query=" + props.data.curLat + "%2C" + props.data.curLng} >
                    <Box sx={{display:'flex', pl:1}}>
                        <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', p:0, m:0}}>
                            <MyLocationIcon sx={{fontSize:'.75em'}} />
                        </Box>
                        <Box sx={{pl:1}}>
                            <Box sx={{display:'flex'}}>
                                <Typography variant="caption" sx={{fontWeight:'bold'}}>lat:</Typography>
                                <Typography variant="caption">{props.data.curLat!=null?props.data.curLat.substring(0,8):""}</Typography>
                            </Box>
                            <Box sx={{display:'flex'}}>
                                <Typography variant="caption" sx={{fontWeight:'bold'}}>lng:</Typography>
                                <Typography variant="caption">{props.data.curLng!=null?props.data.curLng.substring(0,8):""}</Typography>
                            </Box>
                        </Box>
                    </Box>
                </a>
                :
                <a target="_blank" style={{textDecoration:'none', cursor:'pointer', color:'#1976d2'}} href={"https://www.google.com/maps/search/?api=1&query=" + props.data.curLat + "%2C" + props.data.curLng} >
                    <Box sx={{display:'flex', pl:1}}>
                        <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', p:0, m:0}}>
                            <MyLocationIcon sx={{fontSize:'.75em'}} />
                        </Box>
                        <Box sx={{pl:1}}>
                            <Box sx={{display:'flex'}}>
                                <Typography variant="caption">{props.data.curNamedLocation}</Typography>
                            </Box>
                        </Box>
                    </Box>
                </a>
                }
            </Box>
            :
            <Box>
                <Typography variant="body2" sx={{fontWeight:'bold'}}>Location:</Typography>
                <Typography variant="body2" sx={{color:"red"}}>Unknown!</Typography>
            </Box>
        }
        </>
    )
}
